<template>
    <vue-slider
        :title="title"
        :value="value"
        :enable-cross="false"
        :min="min"
        :max="max"
        @change="updateValue"
        :process-style="{ backgroundColor: '#15A9F0' }"
        :tooltip-style="{ backgroundColor: '#15A9F0', borderColor: '#15A9F0' }"
        :locale-string="localeString"
    >
        <template>
            <div class="d-flex justify-content-between pt-2">
                <span v-if="value[0]">{{ localeString ? value[0].toLocaleString() : value[0] }}</span>
                <span  v-if="value[1]">{{ localeString ? value[1].toLocaleString() : value[1] }}</span>
            </div>
        </template>
    </vue-slider>
</template>
<script>
    export default {
        props: {
            title: {
                type: String
            },
            value: {
                type: Array
            },
            min: {
                type: Number,
                default: 0,
            },
            max: {
                type: Number,
                default: 100
            },
            localeString: {
                type: Boolean
            }
        },
        methods: {
            updateValue(e) {
                this.$emit('input', e)
                this.$emit('change', e)
            }
        },
    }
</script>
